import React from "react";
import EventCard from "../Component/EventCard";

console.log(EventCard);
const Event = () => {

    return(
        <div>
            <EventCard/>
        </div>
    )
}
export default Event;